module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand.ac4cc62d.svg";